export default class LocalTimeFormatter {
  public static toAmPmTimeString(timeParts?: number[] | null) {
    if (!timeParts || timeParts.length < 2) {
      return '';
    }

    const AMPM : string = timeParts[0] >= 12 ? 'PM' : 'AM';
    const hourOffsetForAmPm = timeParts[0] > 12 ? timeParts[0] - 12 : timeParts[0];
    const hour : string = (timeParts[0] === 0 ? 12 : hourOffsetForAmPm).toString();
    const minute : string = LocalTimeFormatter.leftPad(timeParts[1]);

    return `${hour}:${minute}${AMPM}`;
  }

  private static leftPad(timeNumber: number) {
    return timeNumber < 10 ? `0${timeNumber}` : `${timeNumber}`;
  }
}
